import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  VStack,
  Image,
} from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';
import { SEO } from '@/components/seo';
import logoImage from '@/assets/images/logo.png';
import { welcomeCopy } from '@/copy';

/**
 * OnboardingQuiz page - Welcome screen before Quiz 1
 *
 * This page introduces new users to the quiz system and explains
 * why they need to take the quiz to build their PersonalTaste profile.
 */
export function OnboardingQuiz() {
  const navigate = useNavigate();

  const handleStartQuiz = () => {
    // Navigate to Quiz 1 (level1)
    navigate({ to: '/quizzes/$quizKey', params: { quizKey: 'level1' } });
  };

  return (
    <Box
      minH="100vh"
      color="white"
      display="flex"
      flexDirection="column"
    >
      <SEO title="Build Your PersonalTaste Profile" />

      <Flex
        direction="column"
        align="center"
        justify="center"
        flex="1"
        p={8}
        textAlign="center"
      >
        <VStack spacing={6} maxW="400px">
          {/* Logo */}
          <Image src={logoImage} alt="Paire Logo" height="120px" mb={2} />

          {/* Header */}
          <VStack spacing={2}>
            <Heading size="lg" color="white">
              {welcomeCopy.heading}
            </Heading>
          </VStack>

          {/* Body */}
          <VStack spacing={4} color="var(--canvas-text-2)">
            {welcomeCopy.body.map((paragraph) => (
              <Text key={paragraph} fontSize="md" lineHeight="1.7">
                {paragraph}
              </Text>
            ))}
          </VStack>

          {/* CTA Button */}
          <Button
            size="lg"
            width="100%"
            mt={4}
            bg="purple.500"
            color="white"
            _hover={{ bg: 'purple.600' }}
            onClick={handleStartQuiz}
            rightIcon={<ChevronRight size={20} />}
            data-testid="onboarding-start-quiz"
          >
            {welcomeCopy.ctaLabel}
          </Button>

          {/* Time estimate */}
          <Text fontSize="sm" color="var(--canvas-text-2)">
            {welcomeCopy.timeEstimate}
          </Text>

          {/* Note */}
          <Text fontSize="sm" color="var(--canvas-text-2)" mt={2}>
            {welcomeCopy.footnote}
          </Text>
        </VStack>
      </Flex>
    </Box>
  );
}

export default OnboardingQuiz;
